/* 🤖 this file was generated by script */
export const wiconCommand = {
  name: 'command',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 9V6a3 3 0 10-3 3h3zm0 0v6m0-6h6m-6 6v3a3 3 0 11-3-3h3zm0 0h6m0 0h3a3 3 0 11-3 3v-3zm0 0V9m0 0V6a3 3 0 113 3h-3z"/></svg>`,
};
